import { Box, styled } from '@mui/material'

export const StyledWidgetDailyChromecastUsage = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  position: 'relative',
  height: '350px',
  width: '100%',
}))
